import { use } from 'react';
import FeatureFlagsContext, { FeatureFlagsContextValue } from './FeatureFlagsContext';

const EMPTY: FeatureFlagsContextValue = {
  flags: {},
  isLoading: false,
  isEnabled: () => false,
};

/**
 * Access the whole feature-flags context (map + isEnabled). Safe outside a provider
 * (returns an empty set where nothing is enabled).
 */
const useFeatureFlags = (): FeatureFlagsContextValue => use(FeatureFlagsContext) ?? EMPTY;

export default useFeatureFlags;
